"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUpdateNotificationEmailsRequestStatus = exports.getFetchNotificationEmailsRequestStatus = exports.getNotificationEmailByTypeForBlogFromCurrentRoute = exports.getNotificationEmails = void 0;

var _reselect = require("reselect");

var _selectors = require("settings-ui-sdk/Routes/selectors");

var _selectors2 = require("settings-ui-sdk/RequestStatuses/selectors");

var _actions = require("./actions");

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-sdk/constants/RequestStatusTypes"));

var getNotificationEmails = function getNotificationEmails(state) {
  return state.modules.website.blogs.entities.notificationEmails;
};

exports.getNotificationEmails = getNotificationEmails;
var getNotificationEmailsForBlogFromCurrentRoute = (0, _reselect.createSelector)([getNotificationEmails, _selectors.getLastNumericTokenFromPath], function (notificationEmails, blogId) {
  return notificationEmails.getIn(['byBlogId', blogId]);
});

var getNotificationEmailByTypeForBlogFromCurrentRoute = function getNotificationEmailByTypeForBlogFromCurrentRoute(type) {
  return (0, _reselect.createSelector)([getNotificationEmailsForBlogFromCurrentRoute], function (notificationEmails) {
    return notificationEmails && notificationEmails.size ? notificationEmails.get(type) : undefined;
  });
};

exports.getNotificationEmailByTypeForBlogFromCurrentRoute = getNotificationEmailByTypeForBlogFromCurrentRoute;

var getFetchNotificationEmailsRequestStatus = function getFetchNotificationEmailsRequestStatus(blogId) {
  return (0, _reselect.createSelector)([_selectors2.getRequestStatuses], function (requestStatuses) {
    return requestStatuses.get(_actions.NotificationEmailsActionTypes.FETCH_NOTIFICATION_EMAILS + "&blogId=" + blogId) || _RequestStatusTypes.default.UNINITIALIZED;
  });
};

exports.getFetchNotificationEmailsRequestStatus = getFetchNotificationEmailsRequestStatus;

var getUpdateNotificationEmailsRequestStatus = function getUpdateNotificationEmailsRequestStatus(blogId) {
  return (0, _reselect.createSelector)([_selectors2.getRequestStatuses], function (requestStatuses) {
    return requestStatuses.get(_actions.NotificationEmailsActionTypes.UPDATE_NOTIFICATION_EMAILS + "&blogId=" + blogId) || _RequestStatusTypes.default.UNINITIALIZED;
  });
};

exports.getUpdateNotificationEmailsRequestStatus = getUpdateNotificationEmailsRequestStatus;